// FEAT-061: 답변 표시용 아주 작은 마크다운 파서.
// 지원: **굵게**, 줄머리 '1. ' / '- ' / '* ' 목록, 빈 줄 문단, 줄바꿈. 링크·이미지·HTML 은 지원하지 않는다.
// HTML 문자열을 만들지 않고 토큰만 반환한다 — React 가 요소로 렌더하므로 <script> 등은 모두 일반 텍스트가 된다.
//
// 반환: Block[]
//   { type: 'p', lines: Inline[][] }       // 문단 (lines 의 각 원소가 한 줄)
//   { type: 'ul' | 'ol', items: Inline[][] }
// Inline = { text: string, bold: boolean }[]

const OL_RE = /^\s*\d+[.)]\s+(.*)$/;
const UL_RE = /^\s*[-*]\s+(.*)$/;

export const parseInline = (text) => {
	const src = String(text ?? '');
	const out = [];
	const re = /\*\*([^*]+?)\*\*/g;
	let last = 0;
	let m;
	while ((m = re.exec(src)) !== null) {
		if (m.index > last) out.push({ text: src.slice(last, m.index), bold: false });
		out.push({ text: m[1], bold: true });
		last = m.index + m[0].length;
	}
	if (last < src.length) out.push({ text: src.slice(last), bold: false });
	return out;
};

export const parseSimpleMarkdown = (input) => {
	const lines = String(input ?? '').replace(/\r\n?/g, '\n').split('\n');
	const blocks = [];
	let cur = null;

	const push = () => {
		if (cur) blocks.push(cur);
		cur = null;
	};

	for (const line of lines) {
		if (line.trim() === '') {
			push();
			continue;
		}
		const ol = line.match(OL_RE);
		const ul = !ol ? line.match(UL_RE) : null;
		if (ol || ul) {
			const type = ol ? 'ol' : 'ul';
			if (!cur || cur.type !== type) {
				push();
				cur = { type, items: [] };
			}
			cur.items.push(parseInline((ol || ul)[1]));
		} else {
			if (!cur || cur.type !== 'p') {
				push();
				cur = { type: 'p', lines: [] };
			}
			cur.lines.push(parseInline(line.trim()));
		}
	}
	push();
	return blocks;
};
